import { render, staticRenderFns } from "./LabelWIcon.vue?vue&type=template&id=6044a408&"
import script from "./LabelWIcon.vue?vue&type=script&lang=js&"
export * from "./LabelWIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports